const FAQ = () => {
  return (
    <div className="row faqs">
      <div className="col s6 m6 l6">
        <h2>FAQs</h2>
      </div>
      <div className="col s6 m6 l6">
        <h3>Learn more about our plans</h3>
      </div>
      <div className="row statements">
        <div className="col s12 m12 l12">
          <h4>Will licenses be fixed to my hardware?</h4>
          <p>
            Vizcom is entirely cloud and web based. You can access it from
            anywhere in the world. Your licence is not tied to any device
          </p>
          <h4>Will you have discounts for students and educators?</h4>
          <p>
            Yep. Just write to us and we'll help you. You can reach out to us at
            contact@vizcom.co
          </p>
          <h4>I need compliance safeguard for my content and data.</h4>
          <p>
            Please reach out to us is you have special security compliance
            requirements (TPN, SOC2 Type II, MPAA, etc). You can email us at
            updates@vizcom.co
          </p>
          <h4>Will my subscription auto-renew</h4>
          <p>
            Yes, your subscription will auto-renew, and your account will be
            charged either once a month or once a year depending on your billing
            period unless your account is disabled.
          </p>
        </div>
      </div>
    </div>
  );
};
export default FAQ;
